import { Component, Input } from '@angular/core';

export function prettyCourseVersion(value: number): string {
  const str = (value || '').toString().split('.')[0];

  if (str.length == 6) {
    const year = str.substring(0, 2);
    // P - pavasaris
    // R - rudens
    // G - gads
    const semester = str[2] == '1' ? 'P' : str[2] == '2' ? 'R' : 'G';
    const version = +str.substring(3);

    return `${year} ${semester} ${version}`;
  }

  return str;
}

@Component({
  selector: 'app-course-version',
  template: `<span class="nowrap">{{display}}</span>`
})
export class CourseVersionComponent {
  @Input() value: number;

  get display(): string {
    return prettyCourseVersion(this.value);
  }
}
